import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DealsEntityService {


  constructor(private http: HttpClient) { }   

  url = environment.serverAPI9 + '/' + 'api/dealsEntity';

  url1 = environment.serverAPI9 + '/' + 'api/dealsEntity/exceltemplate/';


  addDeals(dealsEntity): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, dealsEntity);
  }

  getDealsById(entityId: number): Observable<Object> {
    return this.http.get(`${this.url}/db/${entityId}`);
  }

  downloadDealsReport(id: any): Observable<any> {
    return this.http.get(`${this.url}/exceltemplate/export/${id}`, { responseType: 'arraybuffer', observe: 'response' });
  }


  getAllDealsDetailsByEntityId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/solr/${leadId}`);
  }

  editDeals(dealsEntity, leadId: number): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/edit/${leadId}`, dealsEntity);
  }

  excelImportDeals(data: FormData, id: any): Observable<Object> {
    return this.http.post(`${this.url1}/upload/${id}`, data);
  }

  dealsAlreadyExist(payload): Observable<any> {
    return this.http.post(`${this.url}/check/exist`, payload);
  }

  dealsUrl = environment.serverAPI9 + '/api/deals';

  updateAfterSalesSubStatus(dealId: number, subStatusId: number, notes?: string): Observable<any> {
    const payload = notes ? { notes } : {};
    return this.http.put(`${this.dealsUrl}/${dealId}/after-sales/sub-status/${subStatusId}`, payload);
  }

  updateAfterSalesSubStatusWithImages(dealId: number, subStatusId: number, payload: any): Observable<any> {
    return this.http.put(`${this.dealsUrl}/${dealId}/after-sales/sub-status/${subStatusId}`, payload);
  }

  getAfterSalesHistory(dealId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.dealsUrl}/${dealId}/after-sales/history`);
  }

  initializeAfterSalesPipeline(dealId: number): Observable<any> {
    return this.http.post(`${this.dealsUrl}/${dealId}/after-sales/initialize`, {});
  }

  advanceAfterSalesStage(dealId: number, stageId: number, payload: any): Observable<any> {
    return this.http.put(`${this.dealsUrl}/${dealId}/after-sales/stage/${stageId}`, payload);
  }

}

